import React from 'react';
import { Category } from '@/types/category';
import CategoryVisibilityToggle from './CategoryVisibilityToggle';

interface CreatorCategoryViewProps {
  category: Category;
  userId: string;
  onVisibilityChange: (isPublic: boolean) => void;
  onDeleteCategory: () => void;
}

const CreatorCategoryView: React.FC<CreatorCategoryViewProps> = ({
  category,
  userId,
  onVisibilityChange,
  onDeleteCategory
}) => {
  return (
    <div className="flex items-center">
      <CategoryVisibilityToggle
        categoryId={category.id}
        userId={userId}
        isPublic={category.isPublic || false}
        onVisibilityChange={onVisibilityChange}
        isImported={false}
        onDeleteCategory={onDeleteCategory}
      />
    </div>
  );
};

export default CreatorCategoryView;